import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

export const ModalStyled = styled.div`
  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .formField {
    display: flex;
    flex-direction: column;

    label {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.4;
      color: ${color.text.label};
      margin-bottom: 8px;
      ::after {
        content: '*';
        color: ${color.error.main};
        padding-left: 2px;
      }
    }
  }

  .wrapper-tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border: 1px solid ${color.border.subtle};
    border-radius: 10px;
  }
`
